import { AccessReportsWizardOption } from "@app/access-reports/shared/accessReportsWizardOption";

class AccessReportsWizardDetailsPage {
  accessDetail: boolean;
  accessFilter: AccessReportsWizardOption;
  columns: AccessReportsWizardOption[];
  id: number;
  summarizeBy: AccessReportsWizardOption;

  constructor(accessDetail: boolean, id: number) {
    this.accessDetail = accessDetail;
    this.accessFilter = null;
    this.columns = [];
    this.id = id;
    this.summarizeBy = null;
  }
}

export { AccessReportsWizardDetailsPage };
